import { yesOrNotSelectValidation } from 'helpers/yesOrNo';
import { ObjectSchema, object, TypedForm } from 'libs/form';
import { PriceFieldValue } from 'libs/form/fields/PriceAndCurrencyField';
import { Maybe } from 'types/maybe';
import { NullablePartial } from 'types/nullablePartial';
import { SelectType } from 'types/selectType';
import { YesOrNoType } from 'types/yesOrNo';

import { BaseDebtsFormType, getBaseDebtsItemSchema } from './baseDebtsForm';

export type DebtsOptionalPrice = Maybe<NullablePartial<PriceFieldValue>>;

export interface DebtsFormType {
  debts: BaseDebtsFormType['debts'] & {
    marginTrades: Maybe<SelectType<YesOrNoType>>;
  };
}

export const getDebtsSchema = (
  requireEntrepreneurFields?: boolean
): ObjectSchema<DebtsFormType> =>
  object({
    debts: object({
      marginTrades: yesOrNotSelectValidation.nullable().required(),
    }).concat(getBaseDebtsItemSchema(requireEntrepreneurFields)),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<DebtsFormType>();
